import React from 'react';
import Button from 'material-ui/Button';
import AbstractWidget from './AbstractWidget';
import { Typography } from 'material-ui';
import styles from './NewsItemWidget.css';
import moment from 'moment';
import translate from 'react-i18next/dist/commonjs/translate';
import { getLabels } from '../cmsLib';

class NewsItemWidget extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    getLabels(labels, type) {
        if (labels) {
            return labels[type].value.replace(/(\r\n|\n|\r)/gm, '');
        }
        return null;
    }

    render() {
        const { newsItem, t, widget } = this.props;
        const { parameters } = this.props;
        let title = getLabels(newsItem.labels, 'news.title');
        let description = getLabels(newsItem.labels, 'news.description') || '';
        let creationDate = moment(newsItem.creationDate || new Date()).format('DD MMMM, YYYY');
        const cmsNewsItemWidgetClass = widget && widget.orden === 1 ? 'cmsNewsItemWidgetOrder1' : 'cmsNewsItemWidget';
        const desc = description ? description.substring(0,110) : description;
        const href = `<a href="#/news/${newsItem.id}">${title}</a>`;
        return (newsItem ?
            <div className={cmsNewsItemWidgetClass}>
                <div className="item" key={'new_id' + newsItem.id}>
                    <Typography variant="title" className="title"
                        dangerouslySetInnerHTML={{ __html: window.location.href.indexOf('#/preview') !== -1 ? title : href }} >
                    </Typography>
                    <Typography variant="subheading" className="creationDate">{creationDate}
                    </Typography>
                    <div className={newsItem.listResouce.degraded ? 'imageGradient' : ''}>
                        {parameters && parameters.displayImage ?
                            <img src={newsItem.listResouce.url} className="image" alt={title} />
                            : ''}
                    </div>
                    <Typography className="description" dangerouslySetInnerHTML={{ __html: desc }}></Typography>
                    <Button
                        disabled={window.location.href.indexOf('#/preview') !== -1}
                        component="a" className="readMore" href={`#/news/${newsItem.id}`}>{t('NEWS.READ_MORE_ITEM')}</Button>
                </div>
            </div >
            : '');
    }
}
export default translate('translations')(NewsItemWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/NewsItemWidget.js